import {SignupRequest} from "../models/signup-request.model";
import {PageRequest} from "../models/page-request.model";
import {Cheque, ChequeRequest} from "../models/cheque.model";
import {ChequeCotizacionListFilter} from "../models/cotizacion-list-filter.model";
import {OfertaListFilter} from "../models/oferta.model";

export class SearchOfertaRecibidaListAction {
  static readonly type = "[Cheque] SearchOfertaRecibidaListAction";
  constructor(public payload: { filter: OfertaListFilter }) {}
}
export class SearchOfertaRealizadaListAction {
  static readonly type = "[Cheque] SearchOfertaRealizadaListAction";
  constructor(public payload: { filter: OfertaListFilter }) {}
}

export class AceptarOfertaAction {
  static readonly type = "[Cheque] AceptarOfertaAction";
  constructor(public payload: { ofertaId: number }) {}
}

export class DeclinarOfertaAction {
  static readonly type = "[Cheque] DeclinarOfertaAction";
  constructor(public payload: { ofertaId: number }) {}
}
export class DeclinarOfertaEnviadaAction {
  static readonly type = "[Cheque] DeclinarOfertaEnviadaAction";
  constructor(public payload: { ofertaId: number }) {}
}

export class GetOfertaAction {
  static readonly type = "[Cheque] GetOfertaAction";
  constructor(public payload: { ofertaId: number }) {}
}
